export const ANNOTATION_FONT_SIZE_DEFAULT = 16; // px
export const ANNOTATION_FONT_SIZE_MIN = 9; // px
